import MainLayout from '../../../Components/Layout/MainLayout';
import {Input, Menu, Spin} from 'antd';
import {getRoleList} from '../../../Services/user';
import React, {useState} from 'react';
import styles from './index.module.scss';
import {useMount} from 'react-use';
import {Auth} from '../../../Features/Auth';
import {LinkButton} from '../../../Features/Buttons/LinkButton';
import {ContainerOutlined, PlusSquareOutlined} from '@ant-design/icons';
import useModalHandler from '../../../Utils/Hooks/useModalHandler';
import {RoleModal} from './Components/RoleModal';
import useRequestFn from '../../../Utils/Hooks/useRequestFn';
import {RoleMenuItem} from './Components/RoleMenuItem';
import {RolePanel} from './Components/RolePanel';

export default function RoleManage() {
    const roleModal = useModalHandler({component: RoleModal});
    const [currentId, setCurrentId] = useState('');

    const [refresh, {loading, data: roleList}] = useRequestFn(
        async (searchText?: string) => {
            const data = await getRoleList();
            if (!searchText) return data;
            return data.filter(item => item.roleName.includes(searchText));
        },
    );

    function onSearch(searchText: string) {
        refresh(searchText);
    }

    function onSaveOk() {
        refresh();
        roleModal.close();
    }

    // 默认选中第一个
    useMount(async () => {
        const data = await refresh();
        if (data.length !== 0) setCurrentId(data[0].id);
    });

    return (
        <MainLayout.Page className={styles.root}>
            <Spin spinning={loading}>
                <div className={styles.wrapper}>
                    <div className={styles.left}>
                        <div className={styles.leftHeader}>
                            <div className={styles.leftTop}>
                                <Auth code="SF_J476Zfxw34">
                                    <LinkButton
                                        onClick={() =>
                                            roleModal.open({onOk: onSaveOk})
                                        }>
                                        <PlusSquareOutlined />
                                        添加
                                    </LinkButton>
                                </Auth>
                            </div>

                            <Input.Search
                                placeholder="请输入搜索内容"
                                onSearch={onSearch}
                            />
                        </div>

                        <div className={styles.menu}>
                            <Menu
                                mode="inline"
                                selectedKeys={[currentId]}
                                items={roleList?.map(item => ({
                                    label: (
                                        <RoleMenuItem
                                            data={item}
                                            onChange={refresh}
                                        />
                                    ),
                                    key: item.id,
                                    icon: <ContainerOutlined />,
                                    onClick: () => setCurrentId(item.id),
                                }))}
                            />
                        </div>
                    </div>

                    <div className={styles.main}>
                        {currentId && (
                            <RolePanel key={currentId} roleId={currentId} />
                        )}
                    </div>
                </div>
            </Spin>

            {roleModal.render()}
        </MainLayout.Page>
    );
}
